module.exports = __webpack_public_path__ + "img/exhibit-uploaded.9a508c2e.png";